/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios'
import router from '../router'
import store from '../store'
import ElementUI, {Message} from 'element-ui'
import {removeToken} from '../util/auth'

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
  ElementUI.Notification({
    title: '成功',
    message: msg,
    position: 'bottom-right',
    duration: 2000,
    type: 'success'
  })
}

const errorTip = msg => {
  ElementUI.Message({
    message: msg,
    type: 'error'
  })
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  })
}

/**
 * 请求失败的统一处理
 * @param res 服务器响应
 */
const errorHandle = (res) => {
  // 状态码判断
  switch (res.data.code) {
    case 'A0301':
      errorTip('未登陆或登录过期，请重新登录!')
      removeToken()
      localStorage.removeItem('token')
      // store.commit('loginSuccess', null)
      //中途登录失效后，给user信息重新置空
      store.commit('SET_USERID', {
        userName: null,
        userId: null,
        userToken: null,
        userTypeEnum: null,
        certificateStatus: null,
        userPhone: null,
        type: -1
      })
      router.replace({
        path: '/home',
      })
      // setTimeout(() => {
      //   toLogin()
      // }, 1000)
      break
    case 'A0302':
      errorTip('您没有权限操做此功能!')
      break
    case 'B0001':
      errorTip('系统内部错误!')
      break
    case 'B0101':
      errorTip(res.data.message)
      break
    default:
      //errorTip(other)
      return Promise.resolve(res)
      break
  }
  return Promise.reject(res)
}

// 创建axios实例
// eslint-disable-next-line standard/object-curly-even-spacing
const instance = axios.create({timeout: 1000 * 60})
// 设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。

    let token = router.app.$options.store.state.user.userToken
    if (token === "" || token === null || typeof (token)==='undefined') {
      let localStorage = window.localStorage;
      if (localStorage) {
        token = localStorage.getItem('thesis-userToken');
         if(typeof (token)==='undefined' ||token===null ||token=="null"){
           token=null
         }
      }

    }
    config.headers.common['usertoken'] = token
    return config
  },
  error => Promise.error(error))

/**
 * 响应拦截器
 */
instance.interceptors.response.use(res => {
    // 请求成功
    if(res.status===200){
      if(res.data!=null&&res.config!=null&&res.config.url!=""
        &&res.config.url.indexOf("getWorksOfManager")!=-1){
        return res
      }
    }
    if (res.data.code == undefined) {
      return Promise.reject(res)
    }
    if(res.data.code ==='20001'){
      return Promise.resolve(null)
    }

    if (res.data.code !== '0') {
      let errorResult = ""
      if (res.data.result !== "" && res.data.result !== null) {
        errorResult = res.data.result
      } else {
        errorResult = res.data.message
      }
      Message({
        showClose: true,
        message: errorResult,
        type: 'error'
      });
      return Promise.reject(res)
    } else {
      return Promise.resolve(res)
    }
  },
  // 请求失败
  error => {
    const {response} = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        store.commit('changeNetwork', false)
      } else {
        return Promise.reject(error)
      }
    }
  })

export default instance



// WEBPACK FOOTER //
// ./src/api/http.js